import { useMemo } from "react";

import {
  buildLeadTimeLabel,
  buildRegionalDeliveryTimeLabel,
  resolveUnitDeliveryTime,
  resolveUnitDeliveryTimeLabels,
} from "@/constants/unit-delivery-time.constants";
import useGetAllCustomerConfigurations from "@/hooks/requests/customer-configuration/use-get-all-customer-configurations";

const useUnitDeliveryTime = () => {
  const { data, isLoading, error } = useGetAllCustomerConfigurations({
    pageNumber: 0,
    pageSize: 1,
  });

  const unitDeliveryTime = data?.items[0]?.unitDeliveryTime ?? null;
  const resolvedUnitDeliveryTime = useMemo(
    () => resolveUnitDeliveryTime(unitDeliveryTime),
    [unitDeliveryTime]
  );

  const labels = useMemo(() => resolveUnitDeliveryTimeLabels(unitDeliveryTime), [unitDeliveryTime]);

  const regionalDeliveryTimeLabel = useMemo(
    () => buildRegionalDeliveryTimeLabel(labels.labelForForm),
    [labels.labelForForm]
  );

  const leadTimeLabel = useMemo(
    () => buildLeadTimeLabel(labels.labelForMessage),
    [labels.labelForMessage]
  );

  return {
    unitDeliveryTime,
    resolvedUnitDeliveryTime,
    labelForForm: labels.labelForForm,
    labelForMessage: labels.labelForMessage,
    regionalDeliveryTimeLabel,
    leadTimeLabel,
    isLoading,
    error,
  };
};

export default useUnitDeliveryTime;
